import React from "react";
// import { useDrop } from "react-dnd";

export const GenesisComponent = 
// React.memo(
  React.forwardRef(
    (
      {
        accept,
        index,
        lastDroppedItem,
        // onDrop,
        genesisInfo,
        handleCardChange,
        ...rest
      },
      ref
    ) => {
      // const [{ isOver, canDrop }, drop] = useDrop({
      //   accept,
      //   drop: onDrop,
      //   collect: (monitor) => ({
      //     isOver: monitor.isOver(),
      //     canDrop: monitor.canDrop(),
      //   }),
      // });

      // const isActive = isOver && canDrop;
      // let backgroundColor = "#222";
      // if (isActive) {
      //   backgroundColor = "red";
      // } else {
      //   backgroundColor = "blue";
      // }

      const manageThisActive = () => {
        if (
          parseInt(genesisInfo.activeIndex) !==
          parseInt(lastDroppedItem?.genesisIndex)
        ) {
          handleCardChange(lastDroppedItem);
        }
      };

      return (
        <>
          <div
            // ref={drop}
            className={
              "genesis-col" +
              (parseInt(genesisInfo.activeIndex) ===
              parseInt(lastDroppedItem?.genesisIndex)
                ? " active"
                : "")
            }
            data-testid="genesis_container"
            onClick={manageThisActive}
          >
            {/* {isActive ? (
            <p className={"genesis-col"}>Drop Here</p>
          ) : (
            <p className={"genesis-col"}>
              This Container only Accepts: {accept}
            </p>
          )}

          {lastDroppedItem && (
            <p>Last Dropped Item: {JSON.stringify(lastDroppedItem)}</p>
          )} */}
            <img
              src={lastDroppedItem?.image}
              alt=""
              title=""
              className="img-fluid"
            />
            <p>{lastDroppedItem?.genesisType}</p>
          </div>
        </>
      );
    }
  // )
);
